import ButtonPrimary from 'components/ButtonPrimary'
import { LockIcon } from 'components/Icon/icons/lock'
import { PayPalIcon } from 'components/Icon/icons/paypal'
import Text from 'components/Text'
import { View } from 'components/View'
import formatMessageIntlUtil from 'modules/intl/utils/format-message'
import { getWidthViewportSelect } from 'modules/viewport/selectors'
import React from 'react'
import useIntl from 'modules/component/utils/hooks/useIntl'
import useSelector from 'modules/component/utils/hooks/useSelector.js'
import TextTitleCondensed from 'components/TextTitleCondensed'
import isSmallScreenViewportSelect from 'modules/viewport/selectors/is-small-screen'
import { defineMessages } from 'react-intl'

const messages = defineMessages({
  loading: {
    id: 'FloatingButtonAndPrice.loading',
    defaultMessage: 'Loading...'
  },
  getPremium: {
    id: 'FloatingButtonAndPrice.getPremium',
    defaultMessage: 'Get premium ⭐️'
  }
})

/**
 * @param price
 * @param onClick
 * @param buttonText
 * @param isDisabled
 * @param isLoading
 * @param isPaypal
 * @returns {JSX.Element}
 * @constructor
 */
export default function FloatingButtonAndPrice ({
  price,
  onClick,
  buttonText,
  isDisabled,
  isLoading,
  isPaypal
}) {
  const isSmallScreen = useSelector(isSmallScreenViewportSelect)
  const intl = useIntl()
  const width = useSelector(getWidthViewportSelect)
  const buttonWidth = width * 0.6

  let label
  if (isLoading) {
    label = formatMessageIntlUtil(intl, messages.loading)
  } else {
    label = buttonText || formatMessageIntlUtil(intl, messages.getPremium)
  }

  return (
    <View
      w='100%'
      bgc='white'
      py={2}
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        justifyContent: 'space-around',
        alignItems: 'center',
        borderTop: '1px solid #00000038',
        zIndex: 2
      }}
    >
      <View
        row
        w={isSmallScreen
          ? '100%'
          : '470px'}
        style={{
          justifyContent: 'space-around',
          alignItems: 'center'
        }}
      >
        <TextTitleCondensed
          c='#151D21'
          fw='650'
          fs='26px'
        >
          ${price}
        </TextTitleCondensed>
        {
          isPaypal
            ? (
              <ButtonPrimary
                isDisabled={isDisabled}
                isFullWidth
                onClick={onClick}
                style={{
                  background: '#FFC451',
                  width: isSmallScreen ? `${buttonWidth}px` : '350px',
                  height: '50px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  borderRadius: '12px'
                }}
              >
                <Text
                  c='#151D21'
                  mr
                  fw='590'
                >PAY WITH
                </Text>
                <PayPalIcon />
              </ButtonPrimary>
              )
            : (
              <ButtonPrimary
                isDisabled={isDisabled}
                isFullWidth
                onClick={onClick}
                style={{
                  width: isSmallScreen ? `${buttonWidth}px` : '350px',
                  height: '50px',
                  background: '#1C1C1E',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  borderRadius: '12px'
                }}
              >
                {
                  !isLoading && (
                    <LockIcon />
                  )
                }

                <View ml>
                  <TextTitleCondensed
                    c='#ffffff'
                    fs='18px'
                    fw='760'
                  >
                    {label}
                  </TextTitleCondensed>
                </View>
              </ButtonPrimary>
              )
        }
      </View>
    </View>
  )
}
